import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BarChart3, Sword, Trophy } from 'lucide-react';

const BottomTabBar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    {
      id: 'mystats',
      path: '/mystats',
      label: 'สถิติของฉัน',
      icon: BarChart3,
    },
    {
      id: 'mymatches', 
      path: '/mymatches',
      label: 'แมทซ์ของฉัน',
      icon: Sword,
    },
    {
      id: 'leaderboard',
      path: '/leaderboard', 
      label: 'อันดับ',
      icon: Trophy,
    },
  ];

  const currentPath = location.pathname;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gradient-to-r from-cyan-500 to-blue-600 border-t border-cyan-200 px-4 py-2 safe-area-pb shadow-lg">
      <div className="flex justify-around items-center max-w-md mx-auto">
        {tabs.map((tab) => {
          const isActive = currentPath === tab.path;
          const Icon = tab.icon;
          
          return (
            <button
              key={tab.id}
              onClick={() => navigate(tab.path)}
              className={`flex flex-col items-center py-2 px-3 rounded-lg transition-colors ${
                isActive 
                  ? 'text-white bg-white/20' // Active: สีขาวบน background gradient
                  : 'text-white/70 hover:text-white hover:bg-white/10' // Inactive: สีขาวโปร่งใส
              }`}
            >
              <Icon className={`h-6 w-6 mb-1 ${isActive ? 'text-white' : 'text-white/70'}`} />
              <span className={`text-xs font-medium ${isActive ? 'text-white' : 'text-white/70'}`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomTabBar;